<template>
    <div id="alertes" class="alert-on">

        <a id="toggle-alerts" @click="toggleNotifs">
            <strong>{{ nbNotifs }}</strong>
            <i class="icon-alert"></i>
        </a>

        <ul class="list-alertes">

            <li v-for="notif in orderBy(this.errorsBouteille, 'diff', 'desc')" :key="notif.id">
                <span :class="notif.type_notif">
                    <i :class="'icon-'+notif.type_notif"></i>
                    <p>
                        Retard retour de<br>
                        <strong>{{ Math.floor(notif.diff) }} jour(s)</strong>
                    </p>
                </span>
                <p>
                    Bouteille {{ notif.type }}<br>
                    <strong>{{ notif.code }}</strong>
                </p>
            </li>

            <li v-for="notif in orderBy(this.warningsBouteille, 'diff', 'desc')" :key="notif.id">
                <span :class="notif.type_notif">
                    <i :class="'icon-'+notif.type_notif"></i>
                    <p>
                        Retour dans<br>
                        <strong>{{ Math.abs(Math.floor(notif.diff)) }} jour(s)</strong>
                    </p>
                </span>
                <p>
                    Bouteille {{ notif.type }}<br>
                    <strong>{{ notif.code }}</strong>
                </p>
            </li>

            <li v-for="notif in orderBy(this.warningsOutil, 'diff', 'desc')" :key="notif.id">
                <span :class="notif.type_notif">
                    <i :class="'icon-'+notif.type_notif"></i>
                    <p>
                        Expire le :<br>
                        <strong>{{ notif.date_butoir | dateFormat }}</strong>
                    </p>
                </span>
                <p>
                    {{ notif.type_outil.nom }}
                    <br>
                    <strong>{{ notif.modele }} {{notif.marque }}</strong>
                </p>
            </li>

            <li v-for="notif in errorsOutil" :key="notif.id">
                <span :class="notif.type_notif">
                    <i :class="'icon-'+notif.type_notif"></i>
                    <p>
                        Expiré le :<br>
                        <strong>{{ notif.date_butoir | dateFormat }}</strong>
                    </p>
                </span>
                <p>
                    {{ notif.type_outil.nom }}
                    <br>
                    <strong>{{ notif.modele }} {{notif.marque }}</strong>
                </p>
            </li>

        </ul>

    </div>

</template>

<script>

    import Bouteille from '../../js/models/Bouteille'
    import Outil from '../../js/models/Outil'

    export default {

        data() {
            return {
                errorsOutil: [],
                warningsOutil: [],
                errorsBouteille: [],
                warningsBouteille: []
            }
        },

        methods: {

            orderBy(type, param, sens) {
                return _.orderBy(type, param, sens)
            },

            toggleNotifs() {

                if (this.nbNotifs !== 0) {
                    document.querySelector('.list-alertes').classList.toggle('open');
                }

            },

            fetchNotifs() {
                Bouteille
                    .getWarningsBouteille()
                    .then(data => this.warningsBouteille = data)
                    .catch();

                Bouteille
                    .getErrorsBouteille()
                    .then(data => this.errorsBouteille = data)
                    .catch();

                Outil
                    .getWarningOutils()
                    .then(data => this.warningsOutil = data)
                    .catch();

                Outil
                    .getErrorsOutils()
                    .then(data => this.errorsOutil = data)
                    .catch();
            }

        },

        computed: {

            nbNotifs: function () {
                let total = 0;

                if (this.warningsOutil !== null) {
                    total += this.warningsOutil.length
                }
                if (this.errorsOutil !== null) {
                    total += this.errorsOutil.length
                }
                if (this.warningsBouteille !== null) {
                    total += this.warningsBouteille.length
                }
                if (this.errorsBouteille !== null) {
                    total += this.errorsBouteille.length
                }

                return total
            },

        },

        mounted: function () {

            this.fetchNotifs()

        }
    }

</script>

<style>
    #alertes ul.list-alertes.open {
        display: block;
    }

    #alertes ul.list-alertes li > span.warning {
        color: #f99900;
    }
</style>



// WEBPACK FOOTER //
// NotifBar.vue?61d03ada